export const CONTACT_EMAILS = {
    default: "info@fisp.org.ar",
    educativo: "fispeducativo@fisp.org.ar",
    servicios: "administracion@fisp.org.ar",
    marketing: "marketing@fisp.org.ar",
    fispTv: "marketing@fisp.org.ar",
};

export function getPageContactEmail(pathname = "") {
    if (pathname.startsWith("/educativo") || pathname.startsWith("/curso") || pathname.startsWith("/inscripcion")) {
        return CONTACT_EMAILS.educativo;
    }

    if (
        pathname.startsWith("/servicios/marketing-publicidad") ||
        pathname.startsWith("/servicios/produccion-eventos")
    ) {
        return CONTACT_EMAILS.marketing;
    }

    if (pathname.startsWith("/servicios")) {
        return CONTACT_EMAILS.servicios;
    }

    return CONTACT_EMAILS.default;
}

export function toMailto(email) {
    return `mailto:${email}`;
}
